const requiredFirebaseKeys = [
  "VITE_FIREBASE_API_KEY",
  "VITE_FIREBASE_AUTH_DOMAIN",
  "VITE_FIREBASE_PROJECT_ID",
  "VITE_FIREBASE_APP_ID"
];

const useFirebaseEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === "true";

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

export const appConfig = {
  demoMode: import.meta.env.VITE_DEMO_MODE !== "false",
  useFirebaseEmulators,
  firebaseConfigured: requiredFirebaseKeys.every(key => Boolean(import.meta.env[key])),
  appUrl: import.meta.env.VITE_APP_URL || window.location.origin,
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || "destek@sailforce.net",
  recaptchaEnterpriseSiteKey: import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY || "",
  parentSummaryEmailsEnabled:
    import.meta.env.VITE_PARENT_SUMMARY_EMAILS_ENABLED === "true" || useFirebaseEmulators
};

export const legalVersions = Object.freeze({
  kvkkNotice: "2026-06-25-v1",
  privacy: "2026-06-25-v1",
  terms: "2026-06-25-v1",
  explicitConsent: "2026-06-25-v1"
});
